import React from "react";
import { Theme } from "../../theme";

export const CaretIcon = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="11"
            viewBox="0 0 18 11"
            {...props}
        >
            <path
                data-name="Path 5409"
                d="M9,11,.269,1.676a1.028,1.028,0,0,1,0-1.388.878.878,0,0,1,1.3,0L9,8.223,16.431.287a.878.878,0,0,1,1.3,0,1.03,1.03,0,0,1,0,1.388Z"
                transform="translate(0 0)"
                fill={fill ? fill : Theme.colors.blue}
            />
        </svg>
    );
};
